import { render, staticRenderFns } from "./RecordingsModal.vue?vue&type=template&id=a74cccf2&"
import script from "./RecordingsModal.vue?vue&type=script&lang=js&"
export * from "./RecordingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports